import { CategoriesResponse } from '@shopby/shop-sdk'
import { memo, useCallback, useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { EventDetailProduct, HomeSectionType, SectionDetailType } from '../../@types/home'
import { getSectionsDetail } from '../../api/home'
import { sendSetAppsflyerEvent } from '../../js/postMessage'
import CommonCarousel from '../CommonCarousel'
import ProductCenterModal from '../product/ProductCenterModal'
import ProductModal from '../product/ProductModal'
import { useAppContext } from '../provider/AppProvider'
import HotDealItem from './HotDealItem'
import HotDealTime from './HotDealTime'

interface HotDealProps {
  el: HomeSectionType
  setHotDealCount: React.Dispatch<React.SetStateAction<number>>
  index: number
  category: CategoriesResponse | null
}

const HotDeal = ({ el, setHotDealCount, index, category }: HotDealProps) => {
  const swiperProps = {
    spaceBetween: 8,
    slidesPerView: 1.21957,
    breakpoints: {
      768: {
        spaceBetween: 16,
        slidesPerView: 4,
      },
    },
  }

  const { isAppView } = useAppContext()

  const [sectionItem, setSectionItem] = useState<SectionDetailType | null>(null)
  const [isModal, setIsModal] = useState<boolean>(false)
  const [selectProductNo, setSelectProductNo] = useState<string>('')
  const [like, setLike] = useState<boolean>(false)

  const handleClick = useCallback(() => {
    const gtmNavigateClick: DataLayerArgs = {
      dataLayer: {
        event: 'select_content',
        event_info: {
          content_type: '홈모듈',
          content_id: String(el.sectionNo),
          content_name: el.sectionName,
        },
      },
    }
    if (isAppView) {
      sendSetAppsflyerEvent({
        eventName: 'select_content',
        eventType: {
          content_type: '홈모듈',
          content_id: String(el.sectionNo),
          content_name: el.sectionName,
        },
      })
    }
    TagManager.dataLayer(gtmNavigateClick)
  }, [isAppView, el.sectionNo, el.sectionName])

  useEffect(() => {
    const fetchSectionDetails = async () => {
      try {
        const res = await getSectionsDetail(`${el.sectionNo}`)
        res.data.forEach((el: SectionDetailType) => {
          setSectionItem(el)
          setHotDealCount(el.products.length)
        })
      } catch (err) {
        console.error('Error fetching section details:', err)
      }
    }

    fetchSectionDetails()
  }, [like, el.sectionNo, setHotDealCount])

  if (sectionItem === null) {
    return null
  } else {
    return (
      <>
        <div className='hot_deal' onClick={handleClick}>
          <div className='hot_deal_title'>
            <div className='home_module_title'>
              <p>{sectionItem?.promotionText}</p>
              <p>
                <strong>{sectionItem?.sectionExplain}</strong>
              </p>
            </div>
            <HotDealTime sectionItem={sectionItem} />
          </div>
          <CommonCarousel
            items={sectionItem?.products || []}
            swiperProps={swiperProps}
            renderItem={(element: EventDetailProduct, index: number) => (
              <HotDealItem
                key={element.productNo}
                el={element}
                setIsModal={setIsModal}
                setSelectProductNo={setSelectProductNo}
                setLike={setLike}
                like={like}
                category={category}
                listId={el.sectionNo}
                listName={el.sectionName}
                idx={index}
              />
            )}
          />
          {index !== 0 && <hr />}
        </div>
        {isModal &&
          (isMobile ? (
            <ProductModal
              setIsModal={setIsModal}
              headerText={'옵션선택'}
              selectProductNo={selectProductNo}
              listItem={sectionItem?.products}
              listId={el.sectionNo}
              listName={el.sectionName}
            />
          ) : (
            <ProductCenterModal
              setIsModal={setIsModal}
              headerText={'옵션선택'}
              selectProductNo={selectProductNo}
              listItem={sectionItem?.products}
              listId={el.sectionNo}
              listName={el.sectionName}
            />
          ))}
      </>
    )
  }
}

export default memo(HotDeal)
